/**
 * @file
 */

import { validateOLPContinue } from "@/common/validation/utils.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

// ------------------------------------------------------------------------------------------- 
// SEP 2018 
// ------------------------------------------------------------------------------------------- 
// introduction of responsive web design and responsive data tables has introduced 
// a "feature" whereby if one of the columns moves to the next row,
// there will be two controls with the same ID. One is still in the grid with a display
// option of none, and the other is on the next row
// (In the case of this page, "pay total" and "pay other" columns).
//
// This necessitates renaming the hidden controls so that they do not cause issues with processing.
// ------------------------------------------------------------------------------------------- 

// ======================================================================================
//                               Page Load Logic
// ======================================================================================
export function InitializeOLPPaymentSchedulingPage() {
   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   // -------------------------------------------------------------------------------------------
   // Initialize responseive tables - this is for the pending payments control
   // -------------------------------------------------------------------------------------------
   $('.responsiveTable').DataTable({
      "responsive": true,
      "scrollX": false,
      "paging": false,
      "searching": false,
      "ordering": false,
      "info": false
   });



   $('.flex-PBL-Data-Payment').hide();

   $("[id*='chkPayLoanSeq']").on("click", function () {
      if ($(this).is(":checked")) {
         $(this).closest(".flex-PBL-Header").next(".flex-PBL-Data").find(".flex-PBL-Data-Payment").show(400).find(".PBLPaymentAmount").focus();
         $(this).closest(".flex-PBL-Header").find(".slider").addClass("slider-checked");
      }
      else {
         $(this).closest(".flex-PBL-Header").next(".flex-PBL-Data").find(".flex-PBL-Data-Payment").hide(400);
         $(this).closest(".flex-PBL-Header").find(".slider").removeClass("slider-checked");
      }
   });


   $(".flex-PBL-Container input[type='text']").blur(function (e) {
      setRunningTotal();
   });

   $(".flex-PBL-Container input[type='checkbox']").click(function (e) {
      setRunningTotal();
   });


   // We need to make sure the slider/checkbox and payment textbox are displayed after we return from a postback for
   // all loans that had their slider/checkbox checked
   $("[id*='chkPayLoanSeq']").each(function () {
      if ($(this).is(':checked')) {
         $(this).closest(".flex-PBL-Header").next(".flex-PBL-Data").find(".flex-PBL-Data-Payment").css("display", "flex");
         $(this).closest(".switch").find(".slider.round").addClass("slider-checked");
      }
   });

   // add validation to the PBL total textbox depending on the region in use.
   // pcf 12/10/2018 - Decision was made to have both regions be 0.01 as a minimum.  Leaving this code here, though redundant,
   // in case we come back and need to quickly change the minimum payment. If that is the case I would suggest adding a hidden
   // field with the minimum amount so that we don't need to hardcode the minimum or check region.
   var regionToUse = $("[id$='lblHiddenActiveRegion']").text();
   if (regionToUse == "D") {
      $(".flex-PBL-Total").attr("data-validation-engine", "validate[range[0.01,99999.99]]");
      $(".flex-PBL-Total").attr("data-errormessage-range", "Total amount must be between $0.01 and $99,999.99");
   } else if (regionToUse == "F") {
      $(".flex-PBL-Total").attr("data-validation-engine", "validate[range[0.01,99999.99]]");
      $(".flex-PBL-Total").attr("data-errormessage-range", "Total amount must be between $0.01 and $99,999.99");
   }






  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.setGridTextBoxState = setGridTextBoxState;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.setRunningTotal = setRunningTotal;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.validateOLP = validateOLP;
};

// ======================================================================================
// this function will show or hide the pay by loan data grid and update
// the payment type checkboxes accordingly.
// ======================================================================================
function setGridTextBoxState(state) {
   var PADueRB = $('input:radio[id$="rbPADue"]');

   var PDAmountRB = $('input:radio[id$="rbPDAmount"]');
   var PDAmountText = $(':input[id$="txtPDAmount"]');

   var PBLoanRB = $('input:radio[id$="rbPBLoan"]');

   if (state == 'disable') {
      // ----------------------------------------------------------------------------------------------
      // state is disable, so uncheck pay by loan radio button if it exists and hide the grid.
      // if borrower is not eligible to make a loan item payment, this radio button is not displayed
      // ----------------------------------------------------------------------------------------------
      if (PBLoanRB !== null) {
         PBLoanRB.checked = false;
         $("div[id$='divLLPD']").hide();
      }
      // --------------------------------------------------------------------------------
      // determine which radio button was clicked (pay amount due, pay different amount)
      // and uncheck the other one.
      // --------------------------------------------------------------------------------
      if (PDAmountRB.is(':checked')) {
         PDAmountText.attr("disabled", false);  // ENABLE entry into the pay different amount text box
      }
      else {
         PDAmountText.attr("disabled", true);   // DISABLE entry into the pay different amount text box
         PDAmountText.val('');                  // and remove any amount that borrower may have entered
      }
   }
   else {
      // --------------------------------------------------------------------------------
      // state is enable.  Before switching to pay by Loan, 
      // verify that they are allowed to make line item payments
      // (the code behind will hide the pay by loan radio button if they are not allowed)
      // --------------------------------------------------------------------------------
      if ($('input:radio[id$="rbPBLoan"]').length > 0) {
         PADueRB.checked = false;
         PDAmountRB.checked = false;
         PDAmountText.val('');
         PDAmountText.attr("disabled", true);
         $("div[id$='divLLPD']").show();
      }
   }
}

// ======================================================================================
// total the Loan Level payment Distribution grid
// ======================================================================================
function setRunningTotal() {
   var elementID = '';


   var PBLoanRB = $('input:radio[id$="rbPBLoan"]');
   var PBLoanTotalText = $(':input[id$="txtPBLoan"]');

   var wrkArea = '';
   var paymentTotal = 0;

   var formattedTotal = "";

   if (PBLoanRB !== null)  // if borrower is not eligible to make loan item payments, section will not be displayed
   {
      if (PBLoanRB.is(':checked')) {

         $("[id*='chkPayLoanSeq']").each(function () {
            if ($(this).is(':checked')) {
               wrkArea = $(this).closest(".flex-PBL-Header").next(".flex-PBL-Data").find(".PBLPaymentAmount").val();
               wrkArea = wrkArea.replace(/$/g, '');  // global remove any dollar signs
               wrkArea = wrkArea.replace(/,/g, '');  // global remove any commas
               wrkArea = Number(wrkArea);       // ensure its a number
               if (!isNaN(wrkArea)) {
                  if (wrkArea > 0) {
                     paymentTotal = paymentTotal + wrkArea;
                  }
               }
            }
         });

         // -----------------------------------------------------------------------------------------------------------
         // set the Total Amount textbox with the calculated running total.
         // -----------------------------------------------------------------------------------------------------------
         formattedTotal = paymentTotal.toFixed(2);
         PBLoanTotalText.val(formattedTotal);

      }  //end of check to see if pay by loan button is checked
   } //end of check to see if borrower can even pay by loan
}

// ======================================================================================
// validate and set flag indicator for state of the Add Bank Account window
// ======================================================================================
function validateOLP() {
   if (!validateOLPContinue()) {
      return false;
   }
   else {
      var baHidden = $('[id$="btnAddAcct"].ui-helper-hidden');
      if (typeof baHidden != 'undefined' && baHidden.length > 0) {
         $("[id$='hdnBAstate']").val("N");
      }
      else {
         $("[id$='hdnBAstate']").val("Y");
      }
      return true;
   }
}
